<template>
  <div
    v-show="this.$store.state.layout === 'default'"
    class="min-height-300 position-absolute w-100"
    :class="`${this.$store.state.darkMode ? 'bg-transparent' : 'normalMode'}`"
  />
  <aside
    class="my-3 overflow-auto border-0 sidenav navbar navbar-vertical navbar-expand-xs border-radius-xl"
    :class="`${
      this.$store.state.isRTL
        ? 'me-3 rotate-caret fixed-end'
        : 'fixed-start ms-3'
    } 
    ${
      this.$store.state.layout === 'landing'
        ? 'bg-transparent shadow-none'
        : ' '
    } ${this.$store.state.sidebarType}`"
    id="sidenav-main"
  >
    <div class="sidenav-header">
      <i
        class="top-0 p-3 cursor-pointer fas fa-times text-secondary opacity-5 position-absolute end-0 d-none d-xl-none"
        aria-hidden="true"
        id="iconSidenav"
      ></i>
      <router-link class="m-0 navbar-brand" to="/dashboard">
        <img id="logo-auto" src="./../../../public/img/pngAut.png" />
        <span class="name">AutFriends</span>
      </router-link>
    </div>
    <hr class="mt-0 horizontal dark" />
    <sidenav-list :cardBg="custom_class" />
  </aside>
</template>
<script>
import SidenavList from "./SidenavList.vue";

export default {
  name: "index",
  components: {
    SidenavList,
  },
  data() {
    return {};
  },
  props: ["custom_class", "layout"],
};
</script>
<style scoped>
.normalMode {
  background: #47b0a9;
}
.name {
  color: #47b0a9;
  font-size: 18pt;
  font-weight: 900;
}
.navbar-vertical .navbar-brand > img,
.navbar-vertical .navbar-brand-img {
  max-width: 100%;
  max-height: 3rem;
  margin-right: 10px;
}
</style>